/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetIncursions200Ok
 */
export interface GetIncursions200Ok {
    /**
     * The constellation id in which this incursion takes place
     * @type {number}
     * @memberof GetIncursions200Ok
     */
    constellationId: number;
    /**
     * The attacking faction's id
     * @type {number}
     * @memberof GetIncursions200Ok
     */
    factionId: number;
    /**
     * Whether the final encounter has boss or not
     * @type {boolean}
     * @memberof GetIncursions200Ok
     */
    hasBoss: boolean;
    /**
     * A list of infested solar system ids that are a part of this incursion
     * @type {Array<number>}
     * @memberof GetIncursions200Ok
     */
    infestedSolarSystems: Array<number>;
    /**
     * Influence of this incursion as a float from 0 to 1
     * @type {number}
     * @memberof GetIncursions200Ok
     */
    influence: number;
    /**
     * Staging solar system for this incursion
     * @type {number}
     * @memberof GetIncursions200Ok
     */
    stagingSolarSystemId: number;
    /**
     * The state of this incursion
     * @type {string}
     * @memberof GetIncursions200Ok
     */
    state: GetIncursions200OkStateEnum;
    /**
     * The type of this incursion
     * @type {string}
     * @memberof GetIncursions200Ok
     */
    type: string;
}


/**
 * @export
 */
export const GetIncursions200OkStateEnum = {
    Withdrawing: 'withdrawing',
    Mobilizing: 'mobilizing',
    Established: 'established'
} as const;
export type GetIncursions200OkStateEnum = typeof GetIncursions200OkStateEnum[keyof typeof GetIncursions200OkStateEnum];


/**
 * Check if a given object implements the GetIncursions200Ok interface.
 */
export function instanceOfGetIncursions200Ok(value: object): value is GetIncursions200Ok {
    if (!('constellationId' in value) || value['constellationId'] === undefined) return false;
    if (!('factionId' in value) || value['factionId'] === undefined) return false;
    if (!('hasBoss' in value) || value['hasBoss'] === undefined) return false;
    if (!('infestedSolarSystems' in value) || value['infestedSolarSystems'] === undefined) return false;
    if (!('influence' in value) || value['influence'] === undefined) return false;
    if (!('stagingSolarSystemId' in value) || value['stagingSolarSystemId'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GetIncursions200OkFromJSON(json: any): GetIncursions200Ok {
    return GetIncursions200OkFromJSONTyped(json, false);
}

export function GetIncursions200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIncursions200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'constellationId': json['constellation_id'],
        'factionId': json['faction_id'],
        'hasBoss': json['has_boss'],
        'infestedSolarSystems': json['infested_solar_systems'],
        'influence': json['influence'],
        'stagingSolarSystemId': json['staging_solar_system_id'],
        'state': json['state'],
        'type': json['type'],
    };
}

export function GetIncursions200OkToJSON(json: any): GetIncursions200Ok {
    return GetIncursions200OkToJSONTyped(json, false);
}

export function GetIncursions200OkToJSONTyped(value?: GetIncursions200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'constellation_id': value['constellationId'],
        'faction_id': value['factionId'],
        'has_boss': value['hasBoss'],
        'infested_solar_systems': value['infestedSolarSystems'],
        'influence': value['influence'],
        'staging_solar_system_id': value['stagingSolarSystemId'],
        'state': value['state'],
        'type': value['type'],
    };
}

